import React from "react";
import CssClasses from "./CategoryButton.css";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";

const CategoryButton = props => {
  let classes = [CssClasses.button];

  if (props.isActive) {
    classes.push(CssClasses.active);
  }

  return (
    <div
      onClick={() => {
        props.onButtonClicked(props.id);
      }}
      className={classes.join(" ")}
    >
      <div className={CssClasses.flagImageBox}>
        <img
          src={require("../../../assets/images/flags/" + "hr" + ".png")}
          alt=""
          className={CssClasses.flagImg}
        />
      </div>
      <div className={CssClasses.countIndicatorBox}>
        <span
          className={[
            SiteIcons.site_icon_radiate_left,
            CssClasses.radiateLeft
          ].join(" ")}
        />
        <span className={CssClasses.countNumber}>{props.eventCount}</span>
        <span
          className={[
            SiteIcons.site_icon_radiate_right,
            CssClasses.radiateRight
          ].join(" ")}
        />
      </div>
      <div className={CssClasses.clearFix} />
      <span className={CssClasses.countryName}>{props.title}</span>
    </div>
  );
};

export default CategoryButton;



// WEBPACK FOOTER //
// ./src/Components/UI/CategoryButton/CategoryButton.js